import { render, staticRenderFns } from "./CustomerActListTransferType.vue?vue&type=template&id=3d950c18&"
import script from "./CustomerActListTransferType.vue?vue&type=script&lang=js&"
export * from "./CustomerActListTransferType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports